// Endpoints.
export const DAWA_ENDPOINT: string = 'https://dawa.aws.dk';
export const PROD_URL: string = 'https://tryg.dk';
export const UAT_URL: string = 'https://uat.tryg.dk';
export const API_ENDPOINT: string = '/tryg/api';
export const DEBUG_ENDPOINT: string = '/tryg/api/debug';
export const PACKAGE_ENDPOINT: string = '/tryg/api/json_page';
export const OAUTH_ENDPOINT: string = '/oauth/token?_format=json';

// Actions.
export const API_LOADING: string = 'API_LOADING';
export const API_LOADED: string = 'API_LOADED';

export const OAUTH_REQUEST: string = 'OAUTH_REQUEST';
export const OAUTH_RECEIVE: string = 'OAUTH_RECEIVE';

export const SERVICES_LOADING: string = 'SERVICES_LOADING';
export const SERVICES_LOADED: string = 'SERVICES_LOADED';

// Customer actions.
export const CUSTOMER_CREATE: string = 'CUSTOMER_CREATE';
export const CUSTOMER_CREATED: string = 'CUSTOMER_CREATED';
export const CUSTOMER_UPDATE: string = 'CUSTOMER_UPDATE';
export const CUSTOMER_UPDATED: string = 'CUSTOMER_UPDATED';
export const CUSTOMER_QUOTE: string = 'CUSTOMER_QUOTE';
export const CUSTOMER_QUOTED: string = 'CUSTOMER_QUOTED';
export const CUSTOMER_GET_ACTIVATION_DATE: string = 'CUSTOMER_GET_ACTIVATION_DATE';
export const CUSTOMER_RECEIVED_ACTIVATION_DATE: string = 'CUSTOMER_RECEIVED_ACTIVATION_DATE';
export const UPDATE_QUOTE: string = 'UPDATE_QUOTE';
export const UPDATED_QUOTE: string = 'UPDATED_QUOTE';
export const PORTRAIT_LEAD: string = 'PORTRAIT_LEAD';
export const PORTRAIT_LEAD_CREATED: string = 'PORTRAIT_LEAD_CREATED';

// Accident actions.
export const ACCIDENT_CREATE: string = 'ACCIDENT_CREATE';
export const ACCIDENT_CREATED: string = 'ACCIDENT_CREATED';
export const ACCIDENT_UPDATE: string = 'ACCIDENT_UPDATE';
export const ACCIDENT_UPDATED: string = 'ACCIDENT_UPDATED';
export const ACCIDENT_PREPARE: string = 'ACCIDENT_PREPARE';
export const ACCIDENT_PREPARED: string = 'ACCIDENT_PREPARED';

// Personal actions.
export const PERSONAL_CREATE: string = 'PERSONAL_CREATE';
export const PERSONAL_CREATED: string = 'PERSONAL_CREATED';
export const PERSONAL_UPDATE: string = 'PERSONAL_UPDATE';
export const PERSONAL_UPDATED: string = 'PERSONAL_UPDATED';
export const PERSONAL_PREPARE: string = 'PERSONAL_PREPARE';
export const PERSONAL_PREPARED: string = 'PERSONAL_PREPARED';

// Address actions.
export const GET_ADDRESS_AUTOSUGGEST: string = 'GET_ADDRESS_AUTOSUGGEST';
export const GET_ADDRESS: string = 'GET_ADDRESS';

// Car actions.
export const CAR_CREATE: string = 'CAR_CREATE';
export const CAR_CREATED: string = 'CAR_CREATED';
export const CAR_UPDATE: string = 'CAR_UPDATE';
export const CAR_UPDATED: string = 'CAR_UPDATED';
export const CAR_PREPARE: string = 'CAR_PREPARE';
export const CAR_PREPARED: string = 'CAR_PREPARED';
export const CAR_REGISTRATION_NUMBER_VALID: string = 'CAR_REGISTRATION_NUMBER_VALID';
export const CAR_REGISTRATION_NUMBER_VALIDATED: string = 'CAR_REGISTRATION_NUMBER_VALIDATED';

// Content actions.
export const CONTENT_CREATE: string = 'CONTENT_CREATE';
export const CONTENT_CREATED: string = 'CONTENT_CREATED';
export const CONTENT_UPDATE: string = 'CONTENT_UPDATE';
export const CONTENT_UPDATED: string = 'CONTENT_UPDATED';
export const CONTENT_PREPARE: string = 'CONTENT_PREPARE';
export const CONTENT_PREPARED: string = 'CONTENT_PREPARED';

// House actions.
export const HOUSE_CREATE: string = 'HOUSE_CREATE';
export const HOUSE_CREATED: string = 'HOUSE_CREATED';
export const HOUSE_UPDATE: string = 'HOUSE_UPDATE';
export const HOUSE_UPDATED: string = 'HOUSE_UPDATED';
export const HOUSE_PREPARE: string = 'HOUSE_PREPARE';
export const HOUSE_PREPARED: string = 'HOUSE_PREPARED';

// Purchase actions.
export const PURCHASE: string = 'PURCHASE';
export const PURCHASED: string = 'PURCHASED';
export const SAVE_OFFER: string = 'SAVE_OFFER';
export const SAVED_OFFER: string = 'SAVED_OFFER';
export const RETRIEVE_OFFER: string = 'RETRIEVE_OFFER';
export const RETRIEVED_OFFER: string = 'RETRIEVED_OFFER';

// Travel actions.
export const TRAVEL_CREATE: string = 'TRAVEL_CREATE';
export const TRAVEL_CREATED: string = 'TRAVEL_CREATED';
export const TRAVEL_UPDATE: string = 'TRAVEL_UPDATE';
export const TRAVEL_UPDATED: string = 'TRAVEL_UPDATED';
export const TRAVEL_PREPARE: string = 'TRAVEL_PREPARE';
export const TRAVEL_PREPARED: string = 'TRAVEL_PREPARED';


// Insucrance check action
export const INSURANCE_CHECK_CREATE: string = 'INSURANCE_CHECK_CREATE';
export const INSURANCE_CHECK_CREATED: string = 'INSURANCE_CHECK_CREATED';
export const INSURANCE_RECOMMENDATION_SEND: string = 'INSURANCE_RECOMMENDATION_SEND';
export const INSURANCE_RECOMMENDATION_SENT: string = 'INSURANCE_RECOMMENDATION_SENT';

// Dog actions.
export const DOG_CREATE: string = 'DOG_CREATE';
export const DOG_CREATED: string = 'DOG_CREATED';
export const DOG_UPDATE: string = 'DOG_UPDATE';
export const DOG_UPDATED: string = 'DOG_UPDATED';
export const DOG_PREPARE: string = 'DOG_PREPARE';
export const DOG_PREPARED: string = 'DOG_PREPARED';

// Cat actions.
export const CAT_CREATE: string = 'CAT_CREATE';
export const CAT_CREATED: string = 'CAT_CREATED';
export const CAT_UPDATE: string = 'CAT_UPDATE';
export const CAT_UPDATED: string = 'CAT_UPDATED';
export const CAT_PREPARE: string = 'CAT_PREPARE';
export const CAT_PREPARED: string = 'CAT_PREPARED';


// WEBPACK FOOTER //
// ./src/constants/Api.js